import React from 'react';
import { Helmet } from 'react-helmet';
import { Navigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import TrustSignals from '../login/components/TrustSignals';
import LoginFooter from '../login/components/LoginFooter';
import SignUpForm from './components/SignUpForm';
import { useAuth } from '../../contexts/AuthContext';

const SignUp = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <Icon name="Loader2" size={32} color="var(--color-primary)" className="animate-spin" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (user) return <Navigate to="/service-calculator" replace />;

  return (
    <>
      <Helmet>
        <title>Get Started - eCity Pro | Enterprise Project Estimation Platform</title>
        <meta
          name="description"
          content="Create your eCity Pro account - Enterprise-grade project estimation and procurement management platform"
        />
      </Helmet>

      <div className="min-h-screen bg-background flex items-center justify-center p-4 md:p-6 lg:p-8">
        <div className="w-full max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="lg:pr-8">
                <div className="mb-8 md:mb-10">
                  <h2 className="text-xl md:text-2xl font-bold text-foreground mb-4">
                    Trusted by Industry Leaders
                  </h2>
                  <p className="text-sm md:text-base text-muted-foreground mb-6">
                    Join thousands of professionals managing complex telecom and IT projects with confidence
                  </p>
                </div>
                <TrustSignals />
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto">
                <div className="p-6 md:p-8 lg:p-10 rounded-xl bg-card border border-border shadow-xl">
                  <div className="text-center mb-8 md:mb-10">
                    <div className="flex items-center justify-center mb-6">
                      <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-xl bg-primary/10">
                        <Icon name="Zap" size={32} color="var(--color-primary)" />
                      </div>
                    </div>
                    <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2">
                      Get Started
                    </h1>
                    <p className="text-sm md:text-base text-muted-foreground max-w-md mx-auto">
                      Create your eCity Pro account today
                    </p>
                  </div>
                  <SignUpForm />
                </div>
                <LoginFooter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
